<mat-card class="classInfo">
    <div class="mat-card-header"> 
            <div class="topClassInfo">
                <span class="className" (click)="hideShowClass()"><b>{{classData.Name}}</b></span>
                
                <div class="studentCountBadge"  matTooltip="{{studentActionItemTooltip(classData.Students)}}">
                    <app-notification-badge 
                    [displayString]="studentsWithActionItems(classData.Students)" 
                    [size]="'medium'"
                    [color]="'primary'"
                    ></app-notification-badge>
                </div>

                <div class="menuContainer"> 
                    <button mat-raised-button  [matMenuTriggerFor]="menu" (click)="changeBackgroundColor()">Navigate To
                        <div class="notificationBadge" *ngIf="!classData.CurriculumID">
                            <app-notification-badge 
                            [displayString]="'!'" 
                            [size]="'small'"
                            [color]="'warn'"
                            [hoverString]="'You need to attach a curriculum before assigning a lesson!'"></app-notification-badge>
                        </div>
                    </button>

                    <mat-menu #menu="matMenu">
                            <div *ngIf="classData.CurriculumID"  (click)="saveState()">
                                <a mat-menu-item 
                                href="{{classData.CurriculumUrl}}" 
                                color="primary" 
                                >Curriculum</a>
                            </div>
                            <div *ngIf="!classData.CurriculumID"  (click)="saveState()">
                                <a mat-menu-item 
                                href="/Curriculum/Index" 
                                color="primary" 
                                >Attach Curriculum <div class="notificationBadge" *ngIf="!classData.CurriculumID">
                                    <app-notification-badge 
                                    [displayString]="'!'" 
                                    [size]="'small'"
                                    [color]="'warn'"
                                    [hoverString]="'You need to attach a curriculum before assigning a lesson!'"></app-notification-badge>
                                </div></a>
                            </div>
                            <a mat-menu-item color="primary" href="{{classData.ClassHomePageUrl}}" (click)="saveState()">Class Homepage</a>
                            <a mat-menu-item color="primary" href="/LearningContent/assignmentBrowse.aspx?ClassID={{classData.ID}}" (click)="saveState()">Browse Assignments</a>
                            <a mat-menu-item color="primary" href="/Reports/StudentReports.aspx?ClassID={{classData.ID}}" (click)="saveState()">Student Reports</a>
                            <a mat-menu-item color="primary" routerLink="/ELearning/Class/{{classData.ID}}" (click)="saveState()">Gradebook</a>
                    </mat-menu>
                </div>

                <div class="expandcollapse" 
                 >
                    <mat-icon (click)="hideShowClass()" 
                        *ngIf="!showClass" 
                        style="color: #3e5aa0;" 
                         >expand_less
                    </mat-icon>

                    <mat-icon (click)="hideShowClass()" *ngIf="showClass" style="color: #3e5aa0;" >expand_more</mat-icon>
                   
                </div>
              
            </div>
             
    </div>

    <div *ngIf="showClass">
        <mat-card-content>
            <div *ngIf="hasFilterAndCurrWithAssignments" class="studentsContainer" >
                    <div *ngFor="let student of studentsShown" class="students">
                        <app-elearningdash-student-view 
                        [student]="student" 
                        [classData]="classData"
                        (saveStateEmitter)="saveState()"></app-elearningdash-student-view>
                    </div>
                    <div  class="responses">
                        <div *ngIf="this.classData.Students.length == 0">There are currently no students in this class. Visit the Classroom Homepage or Gradebook.</div>
                        <div *ngIf="classData.Students.length > 0 && studentsShown.length == 0">No students currently need attention. <br> Select 'All' on left to see all students.</div>
                    </div>
            </div>
            
            <div class="responses" *ngIf="!classData.CurriculumID || (classData.CurriculumID && classData.NoLessonsYet)">
                <div *ngIf="!classData.CurriculumID" class="curr-response">
                    There is currently no curriculum attached to this class. 
                    <br>
                    Please go to curriculum search <a href="/Curriculum/Index">here</a> to add a curriculum.
                </div>

                <div *ngIf="classData.CurriculumID && classData.NoLessonsYet" class="curr-response">
                   There are not any student assignments in this class. <br>
                    Click <a href="{{classData.CurriculumUrl}}">here</a> to assign the first lesson.
                </div>
            </div>
           

            
        </mat-card-content>
    </div>
    
</mat-card>